export default __webpack_public_path__ + "media/suspicious_login_attempt/location-15ea92a4.png";